import React, { useState } from 'react'
import { connect } from 'react-redux'
import { Redirect, withRouter } from 'react-router-dom'
import { Collapse, message } from 'antd'
import AdminLayout from '../../components/AdminLayout'
import SectionHeader from '../../components/SectionHeader'
import SectionHeaderTemplate from '../../components/SectionHeaderTemplate'
import SectionContent from '../../components/SectionContent'
import Spin from '../../components/Spin'
import Form from './Form'
import BalanceForm from './BalanceForm'
import ButtonMenuForm from './ButtonMenuForm'
import {
  editForm,
  fetchItem,
  createItem,
  editItem,
  deleteItem,
  reset,
  createItemEPO,
} from '../../actions/sellerForm'
import {
  editBalanceForm,
  addItem,
  reset as resetBalance,
} from '../../actions/sellerBalanceForm'
import {
  fetchItems as fetchButtonMenuItems,
  editButtonMenuForm,
  editItem as editButtonItem,
  reset as resetButtonMenu,
} from '../../actions/sellerButtonMenuForm'
import './index.less'
import PointList from './PointList'
import ChatList from './ChatList'
import { sendParamRequest } from '../../actions/login'
import CryptoJS from 'crypto-js'
import config from '../../config/index'

const { Panel } = Collapse

const listPath = '/admin/sellers'
const itemsTitle = 'Торговые сети'
const itemTitle = 'торговой сетью'
const itemTitleCreate = 'торговую сеть'
const storeKey = 'sellerForm'
// Add module/
const storeBalanceKey = 'sellerBalanceForm'
const storeButtonMenuKey = 'sellerButtonMenuForm'
const storeParams = 'params'
//* *********/

const isEPO = localStorage.getItem('isEPO') === '1'

class ItemForm extends React.Component {
  constructor(props, context) {
    super(props, context)
    this.handleFormOnSubmit = this.handleFormOnSubmit.bind(this)
    this.handleFormOnDelete = this.handleFormOnDelete.bind(this)
    this.formatValues = this.formatValues.bind(this)
    // Add module/
    this.state = { activeKeyPanel: '0' }
    this.handleBalanceFormOnSubmit = this.handleBalanceFormOnSubmit.bind(this)
    this.props.resetBalance()
    this.props.resetButtonMenu()
    this.props.getCommonParams()
    //* *********/
    this.props.reset()
  }

  componentDidMount() {
    if (this.props.location.search === '?points') {
      this.setState({ activeKeyPanel: '3' })
    }

    if (this.props.type === 'edit') {
      this.props.fetchItem({ id: this.props.match.params.itemId })
      this.props.fetchButtonMenuItems({ f_sellers: this.props.match.params.itemId })
    }
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.isCreateItemLoading && nextProps.isCreateItemSuccess) {
      message.success('Новая торговая сеть успешно создана.')
    } else if (this.props.isEditItemLoading && nextProps.isEditItemSuccess) {
      message.success('Данные торговой сети успешно изменены.')
    } else if (this.props.isDeleteItemLoading && nextProps.isDeleteItemSuccess) {
      message.success('Торговая сеть успешно удалена.')
    } else if (this.props.isCreateItemLoading && nextProps.createItemError) {
      message.error(nextProps.createItemError)
    } else if (this.props.isEditItemLoading && nextProps.editItemError) {
      message.error(nextProps.editItemError)
    } else if (this.props.isDeleteItemLoading && nextProps.deleteItemError) {
      message.error(nextProps.deleteItemError)
    // Add module/
    } else if (this.props.isAddItemLoading && nextProps.isAddItemSuccess) {
      message.success('Балан успешно пополнен.')
      this.setState({
        activeKeyPanel: '0',
      })
    } else if (this.props.isAddItemLoading && nextProps.addItemError) {
      message.error(nextProps.addItemError)
    } else if (this.props.isEditButtonMenuItemLoading && nextProps.isEditButtonMenuItemSuccess) {
      // message.success('Параметр успешно изменен.')
      // this.setState({
      //   activeKeyPanel: "0"
      // });
    } else if (this.props.isEditButtonMenuItemLoading && nextProps.editButtonMenuItemError) {
      message.error(nextProps.editButtonMenuItemError)
    //* *********/
    } else if (this.props.isFetchItemLoading && nextProps.fetchItemError) {
      message.error(nextProps.fetchItemError)
    }
  }

  /**
   * Format values before send them to backend.
   * @param values Seller form fields.
   * */
  formatValues(values) {
    return {
      ...values,
      s_phone: values.s_phone.number,
      s_phone_prefix: values.s_phone.prefix,
      s_available_prefixes: JSON.stringify(values.s_available_prefixes),
    }
  }

  handleFormOnSubmit(values) {
    const formattedValues = (!isEPO) ? this.formatValues(values) : values
    
    if (this.props.type === 'create') {
      (!isEPO) ? this.props.createItem(formattedValues) : this.props.createItemEPO(formattedValues)
    } else {
      const item = { ...this.props.item, ...formattedValues }
      this.props.editItem(item)
    }
  }

  handleFormOnDelete() {
    this.props.deleteItem({ id: this.props.match.params.itemId })
  }
  // Add module/
  handleBalanceFormOnSubmit(values) {
    const item = { f_sellers: this.props.match.params.itemId, ...values }
    this.props.addItem(item)
  }

  handleButtonMenuOnChange(idnum, values) {
    const item = { idnum, n_enable: values ? '1' : '0' }
    this.editButtonItem(item)
  }
  //* *********/

  render() {
    const isEPO = localStorage.getItem('isEPO') === '1'
    const {
      type, isCreateItemSuccess, isDeleteItemSuccess, list,
    } = this.props
    const { activeKeyPanel } = this.state

    const isCreateForm = type === 'create'
    const actionTitle = isCreateForm ? 'Создать' : 'Управление'
    // Add module/
    const handleChangeKeyPanel = (e) => {
      this.setState({
        activeKeyPanel: e,
      })
    }
    //* *********/
    if (isCreateItemSuccess || isDeleteItemSuccess) {
      return <Redirect to={listPath} />
    }
    return (
      <div>
        <AdminLayout>
          <SectionHeader>
            <SectionHeaderTemplate
              breadcrumbRoutes={[{ path: '/admin', title: 'Главная' }, { path: listPath, title: itemsTitle }, { title: actionTitle }]}
              title={`${actionTitle} ${isCreateForm ? itemTitleCreate : itemTitle}`}
            />
          </SectionHeader>
          {!isCreateForm && !this.props.isFetchItemLoading &&
            <Collapse className='custom-collapse' accordion bordered={false} onChange={e => handleChangeKeyPanel(e)} activeKey={activeKeyPanel}>
              {!isEPO &&
                <Panel className='custom-accordion-panel' header='Пополнение счета' key='1'>
                  <SectionContent>
                    <BalanceForm
                      onSubmit={this.handleBalanceFormOnSubmit}
                      onFieldsChange={this.props.editBalanceForm}
                      formFieldValues={this.props.formFieldValues}
                      isAddItemLoading={this.props.isAddItemLoading}
                    />
                  </SectionContent>
                </Panel>
              }
              {!isEPO &&
                <Panel className='custom-accordion-panel' header='Управление элементами меню' key='2'>
                  <SectionContent>
                    {(!this.props.isFetchButtonMenuItemsLoading && this.props.items) &&
                      this.props.items.map((item, key) =>
                        (<ButtonMenuForm
                          key={key}
                          keyItem={key}
                          onFieldsChange={this.props.editButtonMenuForm}
                          formFieldValues={item}
                          onChange={this.handleButtonMenuOnChange}
                          isEditButtonMenuItemLoading={this.props.isEditButtonMenuItemLoading}
                          editButtonItem={this.props.editButtonItem}
                        />))}
                  </SectionContent>
                </Panel>
              }
              <Panel className='custom-accordion-panel' header='Управление заведениями' key='3'>
                <SectionContent>
                  <PointList seller={this.props.item} />
                </SectionContent>
              </Panel>
              {!isEPO &&
                <Panel className='custom-accordion-panel' header='Управление чат-ботами' key='4'>
                  <SectionContent>
                    <ChatList seller={this.props.item} />
                  </SectionContent>
                </Panel>
              }
            </Collapse>
          }
          <SectionContent>
            {
              this.props.isFetchItemLoading && <Spin />
            }
            {
              (isCreateForm || (!isCreateForm && this.props.item)) &&
              <Form
                onSubmit={this.handleFormOnSubmit}
                onDelete={this.handleFormOnDelete}
                onFieldsChange={this.props.editForm}
                formFieldValues={this.props.formFieldValues}
                isCreateItemLoading={this.props.isCreateItemLoading}
                isEditItemLoading={this.props.isEditItemLoading}
                isDeleteItemLoading={this.props.isDeleteItemLoading}
                type={this.props.type}
                paramList={list}
              />
            }
          </SectionContent>
        </AdminLayout>
      </div>
    )
  }
}

const mapStateToProps = (state) => {
  const {
    formFieldValues,
    isFetchItemLoading,
    isEditItemLoading,
    isCreateItemLoading,
    isCreateItemSuccess,
    isEditItemSuccess,
    isDeleteItemLoading,
    isDeleteItemSuccess,
    item,
    fetchItemError,
    createItemError,
    editItemError,
    deleteItemError,
  } = state[storeKey]

  // Add module/
  const {
    isAddItemLoading,
    isAddItemSuccess,
    addItemError,
  } = state[storeBalanceKey]
  const {
    items,
    formFieldButtonMenuValues,
    isFetchButtonMenuItemsLoading,
    fetchButtonMenuItemsError,
    isEditButtonMenuItemLoading,
    isEditButtonMenuItemSuccess,
    editButtonMenuItemError,
  } = state[storeButtonMenuKey]

  const {
    list,
  } = state[storeParams]
  //* *********/
  return {
    isFetchItemLoading,
    formFieldValues,
    isEditItemLoading,
    isCreateItemLoading,
    isCreateItemSuccess,
    isEditItemSuccess,
    isDeleteItemLoading,
    isDeleteItemSuccess,
    item,
    // Add module/
    isAddItemLoading,
    isAddItemSuccess,
    addItemError,
    formFieldButtonMenuValues,
    isFetchButtonMenuItemsLoading,
    fetchButtonMenuItemsError,
    isEditButtonMenuItemLoading,
    isEditButtonMenuItemSuccess,
    editButtonMenuItemError,
    items,
    list,
    //* *********/
    fetchItemError,
    createItemError,
    editItemError,
    deleteItemError,
  }
}

const mapDispatchToProps = dispatch => ({
  createItem: params => dispatch(createItem(params)),
  createItemEPO: params => dispatch(createItemEPO(params)),
  editItem: params => dispatch(editItem(params)),
  fetchItem: params => dispatch(fetchItem(params)),
  deleteItem: params => dispatch(deleteItem(params)),
  editForm: formFieldsChange => dispatch(editForm(formFieldsChange)),
  // Add module/
  addItem: params => dispatch(addItem(params)),
  editBalanceForm: formFieldsChange => dispatch(editBalanceForm(formFieldsChange)),
  resetBalance: () => dispatch(resetBalance()),
  fetchButtonMenuItems: params => dispatch(fetchButtonMenuItems(params)),
  editButtonItem: params => dispatch(editButtonItem(params)),
  editButtonMenuForm: formFieldsChange => dispatch(editButtonMenuForm(formFieldsChange)),
  resetButtonMenu: () => dispatch(resetButtonMenu()),
  getCommonParams: () => dispatch(sendParamRequest()),
  //* *********/
  reset: () => dispatch(reset()),
})

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(ItemForm))



// WEBPACK FOOTER //
// src/containers/SellerForm/index.jsx